export const getMovements = (state) => state.movements
export const getTypeReasons = (state) => state.typeReasons
export const getMovementStatus = (state) => state.movementStatus
export const getMovementLineStatus = (state) => state.movementLineStatus